/* NILEVE Theme JS */
(function () {
  'use strict';

  // ─── Fade-up observer ───
  const fadeObserver = new IntersectionObserver(
    (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in-view'); }),
    { threshold: 0.12 }
  );
  document.querySelectorAll('.fade-up').forEach(el => fadeObserver.observe(el));

  // ─── Mobile nav ───
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileNav.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => mobileNav.classList.remove('open'));
    });
  }

  // ─── Reverse wordmark (EVELIN → NILEVE) ───
  const wordmarkWrap = document.getElementById('reverse-wordmark');
  if (wordmarkWrap) {
    const letters = wordmarkWrap.querySelectorAll('.reverse-wordmark-letters span');
    let played = false;
    const slotWidthCh = 1.05;

    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting && !played) { played = true; triggerReverse(); } });
    }, { threshold: 0.45 });
    io.observe(wordmarkWrap);

    function triggerReverse() {
      setTimeout(() => {
        letters.forEach((span, i) => {
          const targetOffset = (5 - i - i) * slotWidthCh;
          span.style.transform = `translateX(${targetOffset}em) rotateY(360deg)`;
          span.style.color = 'var(--color-champagne)';
          span.style.textShadow = '0 0 30px rgba(201,169,110,0.35)';
          span.style.transitionDelay = `${i * 90}ms`;
        });
        const from = wordmarkWrap.querySelector('.rw-from');
        const to = wordmarkWrap.querySelector('.rw-to');
        if (from) { setTimeout(() => { from.style.opacity = '0.4'; }, 100); }
        if (to) { setTimeout(() => { to.style.opacity = '1'; to.style.color = 'var(--color-champagne)'; }, 800); }
      }, 1100);
    }
  }

  // ─── Ritual Constellation ───
  const stage = document.querySelector('.ritual-stage');
  if (stage) {
    const stageObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { stage.classList.add('in-view'); stageObserver.disconnect(); } });
    }, { threshold: 0.25 });
    stageObserver.observe(stage);

    const nodes = stage.querySelectorAll('.ritual-node');
    nodes.forEach(node => {
      node.addEventListener('mouseenter', () => stage.setAttribute('data-hovered', 'true'));
      node.addEventListener('mouseleave', () => stage.setAttribute('data-hovered', 'false'));
      node.addEventListener('focus', () => stage.setAttribute('data-hovered', 'true'));
      node.addEventListener('blur', () => stage.setAttribute('data-hovered', 'false'));
      setTimeout(() => { node.style.opacity = '0'; node.style.transition = 'opacity 600ms ease'; }, 0);
    });

    const nodeObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          nodes.forEach((node, i) => {
            setTimeout(() => { node.style.opacity = '1'; }, 300 + i * 90);
          });
          nodeObserver.disconnect();
        }
      });
    }, { threshold: 0.25 });
    nodeObserver.observe(stage);
  }

  // ─── Product Modal ───
  const modal = document.getElementById('product-modal');
  if (modal) {
    const modalImg = modal.querySelector('.pm-img');
    const modalRange = modal.querySelector('.pm-range');
    const modalTitle = modal.querySelector('.pm-title');
    const modalTagline = modal.querySelector('.pm-tagline');
    const modalWhy = modal.querySelector('.pm-why');
    const modalConnection = modal.querySelector('.pm-connection');
    const modalSymbolizes = modal.querySelector('.pm-symbolizes');
    const modalFocus = modal.querySelector('.pm-focus');

    document.querySelectorAll('[data-product-key]').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.productKey;
        const data = window.NILEVE_PRODUCTS && window.NILEVE_PRODUCTS[key];
        if (!data) return;
        if (modalImg) { modalImg.src = data.img; modalImg.alt = data.name; }
        if (modalRange) modalRange.textContent = 'NILEVE · ' + data.range;
        if (modalTitle) modalTitle.textContent = data.name;
        if (modalTagline) modalTagline.textContent = data.tagline;
        if (modalWhy) modalWhy.textContent = data.why;
        if (modalConnection) modalConnection.textContent = data.connection;
        if (modalSymbolizes) modalSymbolizes.innerHTML = data.symbolizes.map(s => '<li>— ' + s + '</li>').join('');
        if (modalFocus) modalFocus.innerHTML = data.focus.map(s => '<li>— ' + s + '</li>').join('');
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });

    const closeModal = () => { modal.classList.remove('open'); document.body.style.overflow = ''; };
    modal.querySelector('.product-modal-close')?.addEventListener('click', closeModal);
    modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
  }

  // ─── Two Generations slider ───
  const genSlider = document.getElementById('generation-slider');
  const genAdult = document.getElementById('gen-adult-img');
  const genTeen = document.getElementById('gen-teen-img');
  const genBg = document.getElementById('gen-bg');
  const genAdultCaption = document.getElementById('gen-adult-caption');
  const genTeenCaption = document.getElementById('gen-teen-caption');

  if (genSlider && genAdult && genTeen) {
    let autoplayed = false;

    function applyT(t) {
      const adultOpacity = 1 - t;
      const teenOpacity = t;
      const adultFilter = `saturate(${1 - t * 0.35}) hue-rotate(${t * 18}deg)`;
      const teenScale = 0.97 + t * 0.03;
      genAdult.style.opacity = adultOpacity;
      genAdult.style.filter = adultFilter;
      genTeen.style.opacity = teenOpacity;
      genTeen.style.transform = `scale(${teenScale})`;
      if (genBg) {
        const pct = Math.round((1 - t) * 100);
        genBg.style.background = `linear-gradient(135deg, color-mix(in oklab, #EFE9DF ${pct}%, #F4D4D8) 0%, color-mix(in oklab, #F8F6F1 ${pct}%, #CFE3EE) 100%)`;
      }
      if (genAdultCaption) genAdultCaption.style.opacity = 0.4 + (1 - t) * 0.6;
      if (genTeenCaption) genTeenCaption.style.opacity = 0.4 + t * 0.6;
      genSlider.value = Math.round(t * 1000);
    }

    genSlider.addEventListener('input', () => {
      autoplayed = true;
      applyT(genSlider.value / 1000);
    });

    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { autoplayed = true; applyT(0.5); return; }

    const genSection = document.getElementById('generations');
    if (genSection) {
      const genObserver = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting && !autoplayed) {
            autoplayed = true;
            const start = performance.now();
            const duration = 4200;
            const tick = (now) => {
              const p = Math.min(1, (now - start) / duration);
              const eased = p < 0.5
                ? (1 - Math.cos(p * 2 * Math.PI)) / 2
                : (1 - Math.cos((1 - p) * 2 * Math.PI)) / 2;
              applyT(eased);
              if (p < 1) requestAnimationFrame(tick);
              else applyT(0);
            };
            requestAnimationFrame(tick);
          }
        });
      }, { threshold: 0.4 });
      genObserver.observe(genSection);
    }
  }


})();
